export { AccommodationFeaturePills as default } from './accommodation-feature-pills';
export * from './accommodation-feature-pills';
